// Shared MCP (Model Context Protocol) constants. Used by the agents app
// (key creation + per-request access check), the api app (disable on cancel),
// and the admin app (enable/disable/status server-actions).
export const Mcp = {
  // Unkey-specific values for MCP access keys.
  Unkey: {
    KEY_PREFIX: 'fbl_mcp',
    PERMISSION: 'mcp',
  },
};
